function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { __awaiter } from "tslib";
import { Settings } from "../util/Entity";
import { Container } from "./Container";
import { ListData } from "../util/Data";
import * as $array from "../util/Array";
import * as $object from "../util/Object";
/**
 * A base element that holds data bit (data item) for any [[Component]].
 */
export var DataItem = /*#__PURE__*/function (_Settings) {
  _inherits(DataItem, _Settings);
  var _super = _createSuper(DataItem);
  function DataItem(component, dataContext, settings) {
    var _this;
    _classCallCheck(this, DataItem);
    _this = _super.call(this, settings);
    /**
     * A data item's owener [[Component]].
     */
    Object.defineProperty(_assertThisInitialized(_this), "component", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    /**
     * A reference to actual item in source data this item is based on.
     */
    Object.defineProperty(_assertThisInitialized(_this), "dataContext", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    /**
     * @todo requires description
     */
    Object.defineProperty(_assertThisInitialized(_this), "bullets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    /**
     * A set of "open" values.
     */
    Object.defineProperty(_assertThisInitialized(_this), "open", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    /**
     * A set of "close" values.
     */
    Object.defineProperty(_assertThisInitialized(_this), "close", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    _this.dataContext = dataContext;
    _this.component = component;
    _this._settings.visible = true;
    _this._checkDirty();
    return _this;
  }
  /**
   * @ignore
   */
  _createClass(DataItem, [{
    key: "markDirty",
    value: function markDirty() {
      this.component.markDirtyValues(this);
    }
  }, {
    key: "_startAnimation",
    value: function _startAnimation() {
      this.component._root._addAnimation(this);
    }
  }, {
    key: "_animationTime",
    value: function _animationTime() {
      return this.component._root.animationTime;
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      if (this.component) {
        this.component.disposeDataItem(this);
      }
      _get(_getPrototypeOf(DataItem.prototype), "_dispose", this).call(this);
    }
    /**
     * Shows a data item that's currently hidden.
     */
  }, {
    key: "show",
    value: function show(duration) {
      this.setRaw("visible", true);
      if (this.component) {
        this.component.showDataItem(this, duration);
      }
    }
    /**
     * Hides a data item that's currently visible.
     */
  }, {
    key: "hide",
    value: function hide(duration) {
      this.setRaw("visible", false);
      if (this.component) {
        this.component.hideDataItem(this, duration);
      }
    }
  }, {
    key: "isHidden",
    value: function isHidden() {
      return !this.get("visible");
    }
  }]);
  return DataItem;
}(Settings);
/**
 * A base class for elements that make use of data.
 */
export var Component = /*#__PURE__*/function (_Container) {
  _inherits(Component, _Container);
  var _super2 = _createSuper(Component);
  function Component() {
    var _this2;
    _classCallCheck(this, Component);
    _this2 = _super2.apply(this, arguments);
    Object.defineProperty(_assertThisInitialized(_this2), "_data", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListData()
    });
    Object.defineProperty(_assertThisInitialized(_this2), "_dataItems", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(_assertThisInitialized(_this2), "_mainDataItems", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this2._dataItems
    });
    Object.defineProperty(_assertThisInitialized(_this2), "valueFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(_assertThisInitialized(_this2), "fields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: ["id"]
    });
    Object.defineProperty(_assertThisInitialized(_this2), "_valueFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this2), "_valueFieldsF", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this2), "_fields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this2), "_fieldsF", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this2), "_valuesDirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this2), "_dataChanged", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this2), "_dataGrouped", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    /**
     * Indicates if the component has already been initialized.
     */
    Object.defineProperty(_assertThisInitialized(_this2), "inited", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    return _this2;
  }
  /**
   * Component's data.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/data/} for more info
   */
  _createClass(Component, [{
    key: "data",
    get:
    /**
     * @return  Data
     */
    function get() {
      return this._data;
    },
    set: function set(data) {
      data.incrementRef();
      this._data.decrementRef();
      this._data = data;
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      _get(_getPrototypeOf(Component.prototype), "_dispose", this).call(this);
      this._data.decrementRef();
    }
  }, {
    key: "_onDataClear",
    value: function _onDataClear() {}
  }, {
    key: "_afterNew",
    value: function _afterNew() {
      var _this3 = this;
      _get(_getPrototypeOf(Component.prototype), "_afterNew", this).call(this);
      this._data.incrementRef();
      this._updateFields();
      this._disposers.push(this.data.events.onAll(function (change) {
        var dataItems = _this3._mainDataItems;
        _this3.markDirtyValues();
        _this3._markDirtyGroup();
        _this3._dataChanged = true;
        if (change.type === "clear") {
          $array.each(dataItems, function (dataItem) {
            dataItem.dispose();
          });
          dataItems.length = 0;
          _this3._onDataClear();
        } else if (change.type === "push") {
          var dataItem = new DataItem(_this3, change.newValue, _this3._makeDataItem(change.newValue));
          dataItems.push(dataItem);
          _this3.processDataItem(dataItem);
        } else if (change.type === "setIndex") {
          var _dataItem2 = dataItems[change.index];
          var properties = _this3._makeDataItem(change.newValue);
          _dataItem2.bullets = undefined;
          $object.keys(properties).forEach(function (key) {
            _dataItem2.animate({
              key: key,
              to: properties[key],
              duration: _this3.get("interpolationDuration", 0),
              easing: _this3.get("interpolationEasing")
            });
          });
          _dataItem2.dataContext = change.newValue;
        } else if (change.type === "insertIndex") {
          var _dataItem3 = new DataItem(_this3, change.newValue, _this3._makeDataItem(change.newValue));
          dataItems.splice(change.index, 0, _dataItem3);
          _this3.processDataItem(_dataItem3);
        } else if (change.type === "removeIndex") {
          var _dataItem4 = dataItems[change.index];
          _dataItem4.dispose();
          dataItems.splice(change.index, 1);
        } else if (change.type === "moveIndex") {
          var _dataItem5 = dataItems[change.oldIndex];
          dataItems.splice(change.oldIndex, 1);
          dataItems.splice(change.newIndex, 0, _dataItem5);
        } else {
          throw new Error("Unknown IStreamEvent type");
        }
        _this3._afterDataChange();
      }));
    }
  }, {
    key: "_updateFields",
    value: function _updateFields() {
      var _this4 = this;
      if (this.valueFields) {
        this._valueFields = [];
        this._valueFieldsF = {};
        $array.each(this.valueFields, function (key) {
          var field = _this4.get(key + "Field");
          if (field) {
            _this4._valueFields.push(key);
            _this4._valueFieldsF[key] = {
              fieldKey: key + "Field",
              workingKey: key + "Working"
            };
          }
        });
      }
      if (this.fields) {
        this._fields = [];
        this._fieldsF = {};
        $array.each(this.fields, function (key) {
          var field = _this4.get(key + "Field");
          if (field) {
            _this4._fields.push(key);
            _this4._fieldsF[key] = key + "Field";
          }
        });
      }
    }
    /**
     * A list of component's data items.
     *
     * @return  Data items
     */
  }, {
    key: "dataItems",
    get: function get() {
      return this._dataItems;
    }
  }, {
    key: "processDataItem",
    value: function processDataItem(_dataItem) {}
  }, {
    key: "_makeDataItem",
    value: function _makeDataItem(data) {
      var _this5 = this;
      //const output: this["_dataItemSettings"] = {};
      var output = {}; // temporary to solve error
      if (this._valueFields) {
        $array.each(this._valueFields, function (key) {
          var field = _this5.get(_this5._valueFieldsF[key].fieldKey);
          output[key] = data[field];
          output[_this5._valueFieldsF[key].workingKey] = output[key];
        });
      }
      if (this._fields) {
        $array.each(this._fields, function (key) {
          var field = _this5.get(_this5._fieldsF[key]);
          output[key] = data[field];
        });
      }
      return output;
    }
    /**
     * @ignore
     */
  }, {
    key: "makeDataItem",
    value: function makeDataItem(data) {
      var dataItem = new DataItem(this, undefined, data);
      this.processDataItem(dataItem);
      return dataItem;
    }
    /**
     * @ignore
     */
  }, {
    key: "pushDataItem",
    value: function pushDataItem(data) {
      var dataItem = this.makeDataItem(data);
      this._mainDataItems.push(dataItem);
      return dataItem;
    }
    /**
     * @ignore
     */
  }, {
    key: "disposeDataItem",
    value: function disposeDataItem(_dataItem) {}
    /**
     * Shows component's data item.
     *
     * @param   dataItem   Data item
     * @param   _duration  Animation duration in milliseconds
     * @return             Promise
     */
  }, {
    key: "showDataItem",
    value: function showDataItem(dataItem, _duration) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              dataItem.set("visible", true);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
    /**
     * Hides component's data item.
     *
     * @param   dataItem   Data item
     * @param   _duration  Animation duration in milliseconds
     * @return             Promise
     */
  }, {
    key: "hideDataItem",
    value: function hideDataItem(dataItem, _duration) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              dataItem.set("visible", false);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    }
  }, {
    key: "_clearDirty",
    value: function _clearDirty() {
      _get(_getPrototypeOf(Component.prototype), "_clearDirty", this).call(this);
      this._valuesDirty = false;
    }
  }, {
    key: "_afterDataChange",
    value: function _afterDataChange() {}
  }, {
    key: "_afterChanged",
    value: function _afterChanged() {
      _get(_getPrototypeOf(Component.prototype), "_afterChanged", this).call(this);
      if (this._dataChanged) {
        var type = "datavalidated";
        if (this.events.isEnabled(type)) {
          this.events.dispatch(type, {
            type: type,
            target: this
          });
        }
        this._dataChanged = false;
      }
      this.inited = true;
    }
    /**
     * Forces a repaint of the element which relies on data.
     *
     * @since 5.0.21
     */
  }, {
    key: "markDirtyValues",
    value: function markDirtyValues(_dataItem) {
      this.markDirty();
      this._valuesDirty = true;
    }
  }, {
    key: "_markDirtyGroup",
    value: function _markDirtyGroup() {
      this._dataGrouped = false;
    }
    /**
     * @ignore
     */
  }, {
    key: "markDirtySize",
    value: function markDirtySize() {
      this._sizeDirty = true;
      this.markDirty();
    }
  }]);
  return Component;
}(Container);
Object.defineProperty(Component, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Component"
});
Object.defineProperty(Component, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Container.classNames.concat([Component.className])
});